export const MODAL_NAME = 'orders.send-customer-receipt'
